const isLocal = process.env.NODE_ENV === "development";

export const SERVER_URL = isLocal
  ? "http://localhost:8080"
  : "https://nmcregistered.org.uk";

export const DOCUMENTS_URL = isLocal
  ? "http://localhost:8080/uploads/"
  : "https://nmcregistered.org.uk/uploads/";
